<template>

  <div v-if="!useDialog">    
    <v-card>
      <v-toolbar flat color="orange" class="pt-2 ma-4">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-alert</v-icon>
          Alertas a Fincas - {{ awb }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4">
        <contenido-alertas ref="contenido" :awb="awb" @notify="notify" />
      </v-card-text>
    </v-card>
  </div>

  <v-dialog v-else v-model="internalValue" persistent fullscreen hide-overlay transition="dialog-bottom-transition">    
    <v-card>
      <v-toolbar height="40" color="blue" dark flat>
        <v-icon left class="mt-1">mdi-alert</v-icon>
        <span class="mt-1 headline">Alertas a Fincas - {{ awb }}</span>
        <v-spacer></v-spacer>
        <v-btn @click="cerrar" icon dark><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pa-4">
        <contenido-alertas ref="contenido" :awb="awb" @notify="notify" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ContenidoAlertas from "./AlertasContenido.vue";

export default {
  name: "AlertasFinca",
  components: { ContenidoAlertas },
  props: {
    value: { type: Boolean, default: null },
    awb: { type: String, required: true },
  },
  data: () => ({
    internalValue: false,
  }),
  computed: {
    useDialog() {
      return this.value !== null;
    },
  },
  watch: {
    value(val) {
      this.internalValue = val;
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.contenido) {
            this.$refs.contenido.cargarAlertas();
          }
        });
      }
    },
    internalValue(val) {
      if (this.useDialog) {
        this.$emit("input", val);
      }
    },
  },
  mounted() {
    if (!this.useDialog) {
      this.$nextTick(() => {
        if (this.$refs.contenido) {
          this.$refs.contenido.cargarAlertas();
        }
      });
    }    
  },
  methods: {
    cerrar() {
      this.internalValue = false;
    },
    notify(msg) {
      this.$emit("notify", msg);
    },
  },
};
</script>
